// Footer animation: fine strands grow from the footer's base when it scrolls
// into view, sway gently, and part around the pointer.
(() => {
  // Dot tips on the hair strands (read as follicles). Off for now; flip to true to bring them back.
  const SHOW_TIPS = false;
  // The hair strands themselves. Off: nothing is drawn in the footer. Their positions are still
  // computed so the roots in the hidden reveal keep lining up. Flip to true to bring them back.
  const SHOW_STRANDS = false;
  const footer = document.querySelector('.nv-footer-grow');
  const canvas = footer && footer.querySelector('.nv-footer-canvas');
  if (!canvas) return;

  const ctx = canvas.getContext('2d');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pointer = { x: -9999, y: -9999 };
  let strands = [];
  let w = 0;
  let h = 0;
  let growth = reduce ? 1 : 0;
  let visible = false;
  let raf = 0;

  const resize = () => {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    w = footer.clientWidth;
    h = footer.clientHeight;
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    const count = Math.round(Math.min(220, w / 6));
    strands = Array.from({ length: count }, (_, i) => {
      const x = (i / count) * w + (Math.random() - 0.5) * 14;
      return {
        x,
        len: h * (0.28 + Math.random() * 0.5) * (0.55 + 0.45 * Math.sin((x / w) * Math.PI)),
        phase: Math.random() * Math.PI * 2,
        speed: 0.35 + Math.random() * 0.5,
        lean: (Math.random() - 0.5) * 60,
        width: 0.6 + Math.random() * 1.1,
        alpha: 0.18 + Math.random() * 0.34,
        delay: Math.random() * 0.35,
      };
    });
    // Share strand positions with the hidden reveal so each root continues a strand
    footer.nv2Strands = strands;
    footer.dispatchEvent(new CustomEvent('nv2:strands'));
  };

  const ease = (t) => 1 - Math.pow(1 - t, 3);

  const draw = (time) => {
    const t = time / 1000;
    ctx.clearRect(0, 0, w, h);

    if (!SHOW_STRANDS) return;
    for (const s of strands) {
      const g = ease(Math.max(0, Math.min(1, (growth - s.delay) / (1 - s.delay))));
      if (g <= 0) continue;

      const len = s.len * g;
      const sway = reduce ? 0 : Math.sin(t * s.speed + s.phase) * 18;
      let tipX = s.x + s.lean * g + sway;
      const tipY = h - len;

      // Part the strands around the pointer
      const dx = tipX - pointer.x;
      const dy = tipY - pointer.y;
      const dist = Math.hypot(dx, dy);
      if (dist < 160) tipX += (dx / (dist || 1)) * (160 - dist) * 0.6;

      ctx.beginPath();
      ctx.moveTo(s.x, h);
      ctx.quadraticCurveTo(s.x + sway * 0.2, h - len * 0.55, tipX, tipY);
      ctx.strokeStyle = `rgba(239, 233, 223, ${s.alpha})`;
      ctx.lineWidth = s.width;
      ctx.lineCap = 'round';
      ctx.stroke();

      if (!SHOW_TIPS) continue;
      ctx.beginPath();
      ctx.arc(tipX, tipY, s.width * 1.4, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(214, 196, 150, ${s.alpha * 1.6})`;
      ctx.fill();
    }
  };

  const loop = (time) => {
    if (!SHOW_STRANDS) { raf = 0; return; } // 20 Oct: strands are off = nothing to draw, so no per-frame canvas work while the footer shows
    if (growth < 1) growth = Math.min(1, growth + 0.009);
    draw(time);
    raf = visible && !reduce ? requestAnimationFrame(loop) : 0;
  };

  new IntersectionObserver(([entry]) => {
    visible = entry.isIntersecting;
    if (visible) {
      footer.classList.add('is-grown');
      if (reduce) draw(0);
      else if (!raf) raf = requestAnimationFrame(loop);
    }
  }, { threshold: 0.15 }).observe(footer);

  footer.addEventListener('pointermove', (e) => {
    const r = footer.getBoundingClientRect();
    pointer.x = e.clientX - r.left;
    pointer.y = e.clientY - r.top;
  });
  footer.addEventListener('pointerleave', () => { pointer.x = pointer.y = -9999; });

  new ResizeObserver(() => { resize(); if (reduce) draw(0); }).observe(footer);
  resize();
})();
